import { render, staticRenderFns } from "./placeholder-no-campaigns.vue?vue&type=template&id=2757396c"
import script from "./placeholder-no-campaigns.vue?vue&type=script&lang=js"
export * from "./placeholder-no-campaigns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2757396c')) {
      api.createRecord('2757396c', component.options)
    } else {
      api.reload('2757396c', component.options)
    }
    module.hot.accept("./placeholder-no-campaigns.vue?vue&type=template&id=2757396c", function () {
      api.rerender('2757396c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/pages/campaign-scheduling/placeholder-no-campaigns.vue"
export default component.exports